import { writable } from 'svelte/store';

// export const user = writable({});

const storage_roles = localStorage.getItem("roles");

export const roles = writable(storage_roles ? JSON.parse(storage_roles) : []); // storage_user ? JSON.parse(storage_user) : {}

roles.subscribe(value => {
    localStorage.setItem("roles", JSON.stringify(value));
});